<script setup>
import { onBeforeMount, onMounted, onUnmounted, ref, computed } from 'vue'
import { RouterView } from 'vue-router'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale,
} from 'chart.js/auto'
import 'chartjs-adapter-date-fns'
import Toast from '@components/alerts/Toast.vue'
import Loader from '@components/loader/Loader.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import { useAuthStore, useI18nStore } from './store'
import { storeToRefs } from 'pinia'
import { setupRouter } from '@/router'
import useFirebase from '@/composibles/useFirebase'

const authStore = useAuthStore()
const i18nStore = useI18nStore()

const { logout } = authStore
const { lastUserActivityDate, isAuthenticated, accountData } =
  storeToRefs(authStore)
const { defaultLocale } = storeToRefs(i18nStore)
// const { getFcmToken, fcmToken, registerServiceWorker } = useFirebase()

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale,
)

// SESSION MANAGEMENT LOGIC
// to-do: move to a composible
const timer = ref(null)

const props = defineProps({
  timeout: {
    type: Number,
    default: 600000, // 30 minutes in milliseconds
    required: false,
  },
  events: {
    type: Array,
    default: () => [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
    ],
    required: false,
  },
})

const resetTimer = () => {
  lastUserActivityDate.value = Date.now()
  if (timer.value) clearTimeout(timer.value)
  startTimer()
}

const startTimer = () => {
  timer.value = setTimeout(() => {
    const timeSincelastUserActivityDate =
      Date.now() - lastUserActivityDate.value
    if (timeSincelastUserActivityDate >= props.timeout) {
      logout()
    }
  }, props.timeout)
}
// const requestPermissions = () => {
//   Notification.requestPermission()
//     .then((permission) => {
//       if (permission === 'granted') {
//         return
//       }
//     })
//     .catch((error) => {
//       console.error('Error requesting permission:', error)
//     })
// }

onMounted(() => {
  // requestPermissions()
  // registerServiceWorker()
  // getFcmToken()

  props.events.forEach((event) => {
    window.addEventListener(event, resetTimer)
  })
  startTimer()
})

onUnmounted(() => {
  props.events.forEach((event) => {
    window.removeEventListener(event, resetTimer)
  })
  if (timer.value) clearTimeout(timer.value)
})

onBeforeMount(() => {
  window.loading = ref(false)
})

async function created() {
  if (authStore.isAuthenticated && authStore.accountData) {
    await setupRouter(authStore.accountData)
  }
}

// Compute a key that changes with language
const localeKey = computed(() => `app-${defaultLocale.value}`)
</script>

<template>
  <div>
    <RouterView :key="localeKey" />
    <Loader />
  </div>
  <Toast />
</template>

<style scoped>
:deep(.vue-select .menu) {
  max-height: 150px;
  overflow-y: auto;
  display: block;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
